/* eslint-disable react/prop-types */
import { useState } from 'react';
import { Modal, Button, Space, QRCode, Typography, Segmented, Grid } from 'antd';
import { FaQrcode } from 'react-icons/fa';
import PropTypes from 'prop-types';

const { Title } = Typography;
const { useBreakpoint } = Grid;

const doDownload = (url, fileName) => {
  const a = document.createElement('a');
  a.download = fileName;
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const downloadCanvasQRCode = (connectorId) => {
  const canvas = document
    .getElementById(`qrCodeContainer-${connectorId}`)
    ?.querySelector('canvas');

  if (canvas) {
    const url = canvas.toDataURL('image/png');
    doDownload(url, `QRCode-Connector-${connectorId}.png`);
  } else {
    console.error('Canvas QR Code not found');
  }
};

const downloadSvgQRCode = (connectorId) => {
  const svg = document.getElementById(`qrCodeContainer-${connectorId}`)?.querySelector('svg');

  if (svg) {
    const svgData = new XMLSerializer().serializeToString(svg);
    const blob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    doDownload(url, `QRCode-Connector-${connectorId}.svg`);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } else {
    console.error('SVG QR Code not found');
  }
};

const QRCodeModal = ({ isOpen, onClose, chargerId, connectors, customerUrl }) => {
  const [renderType, setRenderType] = useState('svg');
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <FaQrcode className="text-xl" />
          <Title level={4} className="!mb-0">Charger QR Codes</Title>
        </div>
      }
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={isMobile ? '95%' : 1000}
      centered
      className="qr-code-modal"
    >
      <div className="flex flex-col gap-8">
        <div className="flex justify-center">
          <Segmented
            options={[
              { label: 'SVG Format', value: 'svg' },
              { label: 'PNG Format', value: 'canvas' }
            ]}
            value={renderType}
            onChange={setRenderType}
            className="!bg-white"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          {connectors.map((connector) => (
            <div 
              key={connector._id} 
              className="!p-4 transition-shadow duration-300"
            >
              <div className="flex flex-col items-center gap-4">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-500" />
                  <div className="font-semibold text-lg">Connector {connector.connectorId}</div>
                </div>
                
                <div 
                  id={`qrCodeContainer-${connector.connectorId}`}
                >
                  <QRCode
                    size={250}
                    type={renderType}
                    value={`${customerUrl}?chargerId=${chargerId}&connectorId=${connector._id}`}
                    bgColor="#fff"
                    errorLevel="H"
                  />
                </div>

                <Space className="mt-2">
                  <Button
                    type="primary"
                    size="middle"
                    onClick={() => 
                      renderType === 'canvas' 
                        ? downloadCanvasQRCode(connector.connectorId) 
                        : downloadSvgQRCode(connector.connectorId)
                    }
                    className="!flex !items-center !gap-2"
                  >
                    <FaQrcode />
                    Download QR
                  </Button>
                </Space>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

QRCodeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  chargerId: PropTypes.string.isRequired,
  connectors: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    connectorId: PropTypes.string.isRequired,
  })).isRequired,
  customerUrl: PropTypes.string.isRequired,
};

export default QRCodeModal;
